import { createContext } from "react";

const CatTipoCitaContext = createContext();

export default CatTipoCitaContext;
